const phone = '600px';
const tablet = '900px';
const desktop = '1200px';

export const mqSmall = `only screen and (min-width: ${phone})`;
export const mqMedium = `only screen and (min-width: ${tablet})`;
export const mqLarge = `only screen and (min-width: ${desktop})`;
